import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import List from '@material-ui/core/List';
import CredentialItem from '../CredentialItem';
import translations from './translations';
import Settings from '../Settings';

const PAYNL_CREDENTIALS_PATH = 'afosto.tenant.odr.transactions.v1.payment.providers.paynl';
const MOLLIE_CREDENTIALS_PATH = 'afosto.tenant.odr.transactions.v1.payment.providers.mollie';
const CM_PAYMENTS_CREDENTIALS_PATH =
  'afosto.tenant.odr.transactions.v1.payment.providers.cmpayments';

const PaymentCredentialSettings = ({ pathID }) => {
  const intl = useIntl();
  const [hasPermissions, UnauthorizedComponent] = usePermissions(['odr:transactions:create']);
  const hasCredentialPermissions = hasPermissions();

  const getPath = path => (pathID ? path.replace('tenant', pathID) : path);

  if (!hasCredentialPermissions) {
    return (
      <Settings title={intl.formatMessage(translations.title)} isLoading={false}>
        <UnauthorizedComponent showActions={false} />
      </Settings>
    );
  }

  return (
    <Settings title={intl.formatMessage(translations.title)} isLoading={false}>
      <List dense disablePadding>
        <CredentialItem
          appCode="paynl"
          image="/assets/images/paynl-logo.png"
          name="Pay NL"
          path={getPath(PAYNL_CREDENTIALS_PATH)}
          showAction={hasCredentialPermissions}
        />
        <CredentialItem
          appCode="mollie"
          image="/assets/images/mollie-logo.png"
          name="Mollie"
          path={getPath(MOLLIE_CREDENTIALS_PATH)}
          showAction={hasCredentialPermissions}
        />
        <CredentialItem
          appCode="cmpayments"
          divider={false}
          image="/assets/images/cm-logo.png"
          name="CM Payments"
          path={getPath(CM_PAYMENTS_CREDENTIALS_PATH)}
          showAction={hasCredentialPermissions}
        />
      </List>
    </Settings>
  );
};

PaymentCredentialSettings.propTypes = {
  pathID: PropTypes.string,
};

PaymentCredentialSettings.defaultProps = {
  pathID: undefined,
};

export default PaymentCredentialSettings;
